/** Extract a YouTube video id from watch / youtu.be / embed / shorts / iframe paste. */
export function extractYoutubeId(raw) {
    if (!raw) return '';
    const s = String(raw).trim();
    const iframe = s.match(/src=["']([^"']+)["']/i);
    const candidate = iframe ? iframe[1] : s;
    const withProto = /^https?:\/\//i.test(candidate) ? candidate : `https://${candidate}`;
    try {
        const u = new URL(withProto);
        const host = u.hostname.replace(/^www\./, '');
        if (host === 'youtu.be') return u.pathname.slice(1).split('/')[0] || '';
        if (host.endsWith('youtube.com') || host === 'youtube-nocookie.com') {
            if (u.pathname === '/watch') return u.searchParams.get('v') || '';
            const parts = u.pathname.split('/').filter(Boolean);
            const lead = parts[0];
            if (['embed', 'shorts', 'live', 'v'].includes(lead) && parts[1]) return parts[1];
        }
    } catch { /* fall through */ }
    const m = withProto.match(/(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([A-Za-z0-9_-]{11})/);
    return m ? m[1] : '';
}

export function youtubeEmbedUrl(id) {
    return id ? `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1` : '';
}

export function toEmbedUrl(raw) {
    const id = extractYoutubeId(raw);
    return id ? youtubeEmbedUrl(id) : String(raw || '').trim();
}

export function youtubeThumbnailUrl(id) {
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : '';
}
